const baseEndpoint = '/iphone/distributions/:accessKey';

export const paths = {
  show: baseEndpoint,
  installSession: `${baseEndpoint}/install_session`,
  join: `${baseEndpoint}/join`,
  leave: `${baseEndpoint}/leave`,
  displayName: `${baseEndpoint}/display_name`,
  notification: `${baseEndpoint}/notification`,
  comments: `/distributions/:accessKey/comments`,
  commentDetail: `/distributions/:accessKey/comments/:id`,
};
